import { render } from "./WidgetHint.vue?vue&type=template&id=2488826e&scoped=true"
import script from "./WidgetHint.vue?vue&type=script&lang=js"
export * from "./WidgetHint.vue?vue&type=script&lang=js"

import "./WidgetHint.vue?vue&type=style&index=0&id=2488826e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2488826e"]])

export default __exports__